module.exports = __webpack_public_path__ + "assets/img/thumb-AquavistaGlass-Website.eb18d6fe.jpg";